import { useTranslation } from "@coworker/locales";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

export const SelectedArticlesHeader = ({
  numberOfArticles,
}: {
  numberOfArticles: number;
}) => {
  const { t } = useTranslation();
  return (
    <FixaText textStyle="Heading.XS">
      {numberOfArticles === 1
        ? `1 ${t("articleSelectedString")}`
        : t("articlesSelectedCountString", {
            count: numberOfArticles,
          })}
    </FixaText>
  );
};
